module.exports = __webpack_public_path__ + "fd89566f48bb0956e3d48d57cfef2fea.svg";